import { render, staticRenderFns } from "./MhRouterView.vue?vue&type=template&id=325ae68c&"
import script from "./MhRouterView.vue?vue&type=script&lang=js&"
export * from "./MhRouterView.vue?vue&type=script&lang=js&"
import style0 from "./MhRouterView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports